import * as React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Col, Container } from "react-bootstrap";

import Login from "./Pages/Login";
import OTP from "./Pages/OTP";
import Error from "./Pages/Error";
import Success from "./Pages/Success";
import Register from "./Pages/Register";
import useOTPHandler from "./Services/useOTPHandler";
import "./App.css";

export default class App extends React.Component {
  render() {
    return (
      <useOTPHandler.Provider>
        <Router>
          <Container className="w-100 h-100" style={{overflowY: 'auto'}}>
            <Switch>
              <Route exact path="/login/:linkid" component={Login} />
              <Route exact path="/otp" component={OTP} />
              <Route exact path="/success" component={Success} />
              <Route exact path="/register" component={Register} />
              <Route exact path="/" component={Login} />
              <Route component={Error} />
            </Switch>
          </Container>
        </Router>
      </useOTPHandler.Provider>
    );
  }
}
